// Print slots used by Document Design templates. Sizes in inches include 0.125" bleed where full-bleed.
export const PRINT_DPI = 300;

export const LAYOUT_SLOTS = [
  { id: 'cover', label: 'Cover (full bleed, Letter)', widthIn: 8.75, heightIn: 11.25 },
  { id: 'section-opener', label: 'Section opener (half page)', widthIn: 8.75, heightIn: 5.5 },
  { id: 'landscape-page', label: 'Full page landscape', widthIn: 11.25, heightIn: 8.75 },
  { id: 'figure', label: 'Body figure (6.5" wide)', widthIn: 6.5, heightIn: 4.33 },
  { id: 'inset', label: 'Inset (3" x 2")', widthIn: 3, heightIn: 2 },
];

export const COVER_READY_FILTER = {
  orientation: 'portrait',
  min_width: Math.round(8.75 * PRINT_DPI),
  min_height: Math.round(11.25 * PRINT_DPI),
};

/**
 * Effective print resolution when the image is scaled and cropped to fill the slot.
 * @returns {{ dpi: number|null, rating: 'vector'|'good'|'fair'|'low'|'unknown', cropPct: number }}
 */
export function slotFitness(asset, slot) {
  if (asset?.is_vector) return { dpi: null, rating: 'vector', cropPct: 0 };
  const w = asset?.width_px;
  const h = asset?.height_px;
  if (!w || !h) return { dpi: null, rating: 'unknown', cropPct: 0 };

  const dpi = Math.floor(Math.min(w / slot.widthIn, h / slot.heightIn));
  const imageRatio = w / h;
  const slotRatio = slot.widthIn / slot.heightIn;
  const cropPct = Math.round((1 - Math.min(imageRatio, slotRatio) / Math.max(imageRatio, slotRatio)) * 100);

  let rating = 'low';
  if (dpi >= PRINT_DPI) rating = 'good';
  else if (dpi >= 200) rating = 'fair';
  return { dpi, rating, cropPct };
}

export function formatBytes(bytes) {
  if (!bytes && bytes !== 0) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
